import { Moment, unitOfTime } from 'moment';
import Customer, { ContactTarget } from '@/customer/models/Customer';
import MediaFile from '@/general/models/MediaFile';
import { JobId } from '@/jobs/models/AbstractJob';
import Job from '@/jobs/models/Job';
import User from '@/shared/models/User';
import { present } from '@/shared/utils/typescript';
import ChatJobStatus from '../constants/ChatJobStatus';
import { ChatId } from './ids';

export interface ChatMessageId {__chatMessageId: number}

export class ChatJob {
  id!: JobId;
  sequenceNumber = 0;
  description = '';
  status = ChatJobStatus.NEW;
  statusBy!: User;

  static fromJob(job: Job, user: User): ChatJob {
    const chatJob = new ChatJob();
    chatJob.id = present(job.id);
    chatJob.description = job.description.content;
    chatJob.sequenceNumber = job.sequenceNumber;
    chatJob.statusBy = user;
    return chatJob;
  }
}

export default class ChatMessage {
  id!: ChatMessageId;
  chatId!: ChatId;
  targets: Array<ContactTarget> = [];
  content: string | null = null;
  media: MediaFile | null = null;
  job: ChatJob | null = null;
  createdOn: Moment | null = null;
  createdBy: Customer | User | null = null;

  hasSameCreator(that: ChatMessage): boolean {
    if (!this.createdBy || !that.createdBy) return false;
    if (this.createdBy.constructor !== that.createdBy.constructor) return false;
    return this.createdBy.fullName === that.createdBy.fullName;
  }

  withinSameTimeframe(that: ChatMessage, timeframe = 10, unit: unitOfTime.Diff = 'minutes'): boolean {
    if (!this.createdOn || !that.createdOn) return false;
    return Math.abs(this.createdOn.diff(that.createdOn, unit)) < timeframe;
  }

  async preloadMediaThumbnail(): Promise<void> {
    await this.media?.preloadThumbnail();
  }
}